module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-企业社会责任.74aa7bbf.png";